module.exports = __webpack_public_path__ + "static/media/win.2b66f283.mp3";